!function (angular) {
    'use strict';

    angular.module('cache.interceptor', []).factory('cacheBusterInterceptor', [function() {
        return {
            'request': function (config) {
                if(config.url.indexOf('.html') < 0) {
                    var timestamp = new Date().getTime();
                    if (config.url.indexOf('?') > -1) {
                        config.url = config.url + '&noCache=' + timestamp;
                    }
                    else {
                        config.url = config.url + '?noCache=' + timestamp;
                    }
                }

                return config;
            }
        };
    }])
}(angular);